export default "__VITE_ASSET__BkyCctuz__"